import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatButton } from '@angular/material/button'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import { HealthUnitCreateComponent } from '../../../features/health-unit/health-unit-create/health-unit-create.component'
import { HealthUnitEditComponent } from '../../../features/health-unit/health-unit-edit/health-unit-edit.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {AlertRuleService} from '../../../core/services/alert-rule/alert-rule/alert-rule.service';
import {AlertRuleCreateComponent} from '../../../features/alert-rule/alert-rule-create/alert-rule-create.component';
import {AlertRuleEditComponent} from '../../../features/alert-rule/alert-rule-edit/alert-rule-edit.component';

@Component({
  selector: 'alert-rule',
  imports: [
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    FormSearchComponent,
    MatButton,
    MatPaginatorModule,
  ],
  templateUrl: './alert-rule.component.html',
  styleUrl: './alert-rule.component.scss',
  providers: [AlertRuleService, AuthService],
  standalone: true,
})
export class AlertRuleComponent implements OnInit {
  constructor(
    private locationService: AlertRuleService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'tipo_exame_nome',
      key: 'tipo_exame_nome',
      description: 'Tipo Exame',
    },
    {
      keyColumn: 'contexto_nome',
      key: 'contexto_nome',
      description: 'Contexto de Medição',
    },
    {
      keyColumn: 'classificacao_nome',
      key: 'classificacao_nome',
      description: 'Classificação',
    },
    {
      keyColumn: 'templates_mensagem',
      key: 'templates_mensagem',
      description: 'Mensagem',
    },
    {
      keyColumn: 'ativo',
      key: 'ativo',
      description: 'Ativo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'regra-alerta'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.paging.total
  }

  getListItems() {
    this.loading = true
    this.locationService.listPagedLocation(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }
  searchListItems() {
    this.loading = true
    this.locationService
      .searchPagedLocation(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newEmployee() {
    const dialogRef = this.dialog.open(AlertRuleCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList()
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(AlertRuleEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
      data: { item },
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
